import { render, staticRenderFns } from "./CheckboxField.vue?vue&type=template&id=8e80e7ea"
import script from "./CheckboxField.vue?vue&type=script&lang=js"
export * from "./CheckboxField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports